<div class="overflow-y-auto height-without-bar lg:h-full">
  <section class="px-[0.75rem] pb-28 pt-4 lg:pt-20">
    <div class="mx-auto max-w-5xl">
      @if (isLoadingEligibility() || eligibilityError() || !hasAcceptedProgram() || !canContribute()) {
        <div class="flex items-center">
          <a
            routerLink="/"
            class="ugc-create-back"
            [attr.aria-label]="'ugc_create.back_home' | translate">
            <svg class="h-4 w-4" fill="none" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.49887 1.57579C6.85935 1.21531 6.85935 0.630847 6.49887 0.270363C6.13838 -0.090121 5.55392 -0.090121 5.19344 0.270363L0.270363 5.19344C0.090121 5.37368 0 5.60992 0 5.84615C0 5.97131 0.0249097 6.09066 0.0700419 6.19949C0.115088 6.30837 0.181862 6.41037 0.270363 6.49887L5.19344 11.4219C5.55392 11.7824 6.13838 11.7824 6.49887 11.4219C6.85935 11.0615 6.85935 10.477 6.49887 10.1165L3.15158 6.76923H15.0769C15.5867 6.76923 16 6.35595 16 5.84615C16 5.33635 15.5867 4.92308 15.0769 4.92308H3.15158L6.49887 1.57579Z"
                fill="currentColor" />
            </svg>
          </a>
        </div>
      }

      @if (!isLoadingEligibility() && !eligibilityError() && !hasAcceptedProgram()) {
        <section class="ugc-create-panel mt-6 lg:grid lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end lg:gap-6">
          <div>
            <h2 class="text-2xl font-semibold text-black">
              {{ getProgramGateTitleKey() | translate }}
            </h2>
            <p class="mt-3 text-sm leading-6 text-theme-body">
              {{ getProgramGateBodyKey() | translate }}
            </p>
          </div>

          <div class="mt-5 flex flex-col gap-3 lg:mt-0">
            <a
              routerLink="/ugc/program"
              class="ugc-create-primary-action">
              {{ 'ugc_create.program_gate.primary_cta' | translate }}
            </a>
            <a
              routerLink="/"
              class="ugc-create-secondary-action">
              {{ 'ugc_create.program_gate.secondary_cta' | translate }}
            </a>
          </div>
        </section>
      } @else if (!isLoadingEligibility() && !eligibilityError() && !canContribute()) {
        <section class="ugc-create-panel ugc-create-panel--warning mt-6">
          <p class="text-sm font-semibold text-theme-base">
            {{ 'ugc_create.eligibility.blocked_title' | translate }}
          </p>
          <p class="mt-2 text-sm leading-6 text-theme-body">
            {{ 'ugc_create.eligibility.blocked_body' | translate }}
          </p>

          <div class="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <article class="rounded-[1.2rem] border bg-white/75 p-3 [border-color:rgba(var(--theme-color-primary-rgb),0.12)]">
              <p class="text-[0.68rem] font-bold uppercase leading-[1.35] tracking-[0.12em] text-[var(--theme-color-text-muted)]">
                {{ 'ugc_create.stats.reputation' | translate }}
              </p>
              <p class="mt-1.5 text-[1.35rem] font-bold leading-none text-[var(--theme-color-text-base)]">
                {{ eligibility()?.currentReputation ?? '-' }}
              </p>
            </article>

            <article class="rounded-[1.2rem] border bg-white/75 p-3 [border-color:rgba(var(--theme-color-primary-rgb),0.12)]">
              <p class="text-[0.68rem] font-bold uppercase leading-[1.35] tracking-[0.12em] text-[var(--theme-color-text-muted)]">
                {{ 'ugc_create.stats.minimum_reputation' | translate }}
              </p>
              <p class="mt-1.5 text-[1.35rem] font-bold leading-none text-[var(--theme-color-text-base)]">
                {{ eligibility()?.minimumRequiredReputation ?? '-' }}
              </p>
            </article>

            <article class="rounded-[1.2rem] border bg-white/75 p-3 [border-color:rgba(var(--theme-color-primary-rgb),0.12)]">
              <p class="text-[0.68rem] font-bold uppercase leading-[1.35] tracking-[0.12em] text-[var(--theme-color-text-muted)]">
                {{ 'ugc_create.stats.pending' | translate }}
              </p>
              <p class="mt-1.5 text-[1.35rem] font-bold leading-none text-[var(--theme-color-text-base)]">
                {{ eligibility()?.pendingSubmissions ?? '-' }}
              </p>
            </article>

            <article class="rounded-[1.2rem] border bg-white/75 p-3 [border-color:rgba(var(--theme-color-primary-rgb),0.12)]">
              <p class="text-[0.68rem] font-bold uppercase leading-[1.35] tracking-[0.12em] text-[var(--theme-color-text-muted)]">
                {{ 'ugc_create.stats.pending_limit' | translate }}
              </p>
              <p class="mt-1.5 text-[1.35rem] font-bold leading-none text-[var(--theme-color-text-base)]">
                {{ eligibility()?.maxPendingSubmissions ?? '-' }}
              </p>
            </article>
          </div>

          @if (eligibilityBlockedReasonKeys().length) {
            <div class="mt-4 rounded-[1.25rem] border bg-white/75 p-4 [border-color:rgba(var(--theme-color-primary-rgb),0.12)]">
              <p class="text-[0.72rem] font-bold uppercase leading-[1.2] tracking-[0.12em] text-[var(--theme-color-text-muted)]">
                {{ 'ugc_create.eligibility.reasons_title' | translate }}
              </p>

              <div class="mt-3 grid gap-2">
                @for (reasonKey of eligibilityBlockedReasonKeys(); track reasonKey) {
                  <div class="flex items-start gap-2 text-[0.88rem] leading-6 text-[var(--theme-color-text-base)]">
                    <span class="mt-[0.43rem] inline-flex h-2 w-2 flex-shrink-0 rounded-full bg-[var(--theme-color-primary)]" aria-hidden="true"></span>
                    <span>
                      {{ reasonKey | translate: {
                        current: eligibility()?.currentReputation,
                        minimum: eligibility()?.minimumRequiredReputation,
                        pending: eligibility()?.pendingSubmissions,
                        max: eligibility()?.maxPendingSubmissions
                      } }}
                    </span>
                  </div>
                }
              </div>
            </div>
          }
        </section>
      } @else {
        <section class="mt-6">
          <section class="ugc-create-stage-header">
            <div class="ugc-create-stage-header__bar">
              <a
                routerLink="/"
                class="ugc-create-back ugc-create-back--header"
                [attr.aria-label]="'ugc_create.back_home' | translate">
                <svg class="h-4 w-4" fill="none" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.49887 1.57579C6.85935 1.21531 6.85935 0.630847 6.49887 0.270363C6.13838 -0.090121 5.55392 -0.090121 5.19344 0.270363L0.270363 5.19344C0.090121 5.37368 0 5.60992 0 5.84615C0 5.97131 0.0249097 6.09066 0.0700419 6.19949C0.115088 6.30837 0.181862 6.41037 0.270363 6.49887L5.19344 11.4219C5.55392 11.7824 6.13838 11.7824 6.49887 11.4219C6.85935 11.0615 6.85935 10.477 6.49887 10.1165L3.15158 6.76923H15.0769C15.5867 6.76923 16 6.35595 16 5.84615C16 5.33635 15.5867 4.92308 15.0769 4.92308H3.15158L6.49887 1.57579Z"
                    fill="currentColor" />
                </svg>
              </a>

              <div class="ugc-create-stage-header__bar-content">
                <p class="ugc-create-stage-header__eyebrow">
                  {{ 'ugc_create.stage_header.eyebrow' | translate }}
                </p>
                <h1 class="ugc-create-stage-header__title">
                  {{ getStageTitleKey() | translate }}
                </h1>
              </div>

              <span class="ugc-create-stage-header__spacer" aria-hidden="true"></span>
            </div>

            <div class="ugc-create-stage-header__details">
              <span class="ugc-create-stage-header__territory">
                {{ 'ugc_create.stage_header.territory' | translate }}: {{ territoryCode() }}
              </span>
              <p class="ugc-create-stage-header__body">
                {{ getFlowHintKey() | translate }}
              </p>
            </div>

            <div class="ugc-create-stepper">
              <span
                class="ugc-create-stepper__item"
                [class.ugc-create-stepper__item--reached]="stageIndex() >= 1"
                [class.ugc-create-stepper__item--current]="stageIndex() === 1">
                <span class="ugc-create-stepper__index">1</span>
                <span class="ugc-create-stepper__label">
                {{ 'ugc_create.step_chips.name' | translate }}
                </span>
              </span>
              <span
                class="ugc-create-stepper__item"
                [class.ugc-create-stepper__item--reached]="stageIndex() >= 2"
                [class.ugc-create-stepper__item--current]="stageIndex() === 2">
                <span class="ugc-create-stepper__index">2</span>
                <span class="ugc-create-stepper__label">
                {{ 'ugc_create.step_chips.photo' | translate }}
                </span>
              </span>
              <span
                class="ugc-create-stepper__item"
                [class.ugc-create-stepper__item--reached]="stageIndex() >= 3"
                [class.ugc-create-stepper__item--current]="stageIndex() === 3">
                <span class="ugc-create-stepper__index">3</span>
                <span class="ugc-create-stepper__label">
                {{ 'ugc_create.step_chips.review' | translate }}
                </span>
              </span>
            </div>
          </section>

          @if (flowStep() === 'name' || flowStep() === 'check') {
            <div class="mt-6 space-y-4">
              <section class="ugc-create-search-panel">
                <div class="ugc-create-search-panel__header">
                  <div>
                    <p class="ugc-create-search-panel__eyebrow">
                      {{ (flowStep() === 'check' ? 'ugc_create.matches.results_eyebrow' : 'ugc_create.name_step.label') | translate }}
                    </p>
                    <h1 class="ugc-create-search-panel__title">
                      {{ (flowStep() === 'check' ? 'ugc_create.matches.quick_title' : 'ugc_create.name_step.quick_title') | translate }}
                    </h1>
                    <p class="ugc-create-search-panel__hint">
                      {{ (flowStep() === 'check' ? 'ugc_create.matches.quick_hint' : 'ugc_create.name_step.quick_hint') | translate }}
                    </p>
                  </div>
                </div>

                <div class="ugc-create-search-input-shell mt-4">
                  <div class="ugc-create-search-input-shell__icon" aria-hidden="true">
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                      <circle cx="11" cy="11" r="7"></circle>
                      <path d="m20 20-3.5-3.5"></path>
                    </svg>
                  </div>

                  <input
                    id="ugc-xplore-name"
                    type="text"
                    class="ugc-create-search-input"
                    [value]="xploreName()"
                    [placeholder]="'ugc_create.name_step.placeholder' | translate"
                    (input)="onNameInput($any($event.target).value)"
                    (keydown.enter)="submitName()">
                </div>

                <div class="ugc-create-search-helper">
                  @if (isCheckingName()) {
                    <span class="ugc-create-inline-spinner" aria-hidden="true"></span>
                    <span>{{ 'ugc_create.name_step.checking' | translate }}</span>
                  } @else {
                    <span>{{ 'ugc_create.name_step.micro_hint' | translate }}</span>
                  }
                </div>

                @if (nameError()) {
                  <p class="mt-3 text-sm text-rose-600">{{ 'ugc_create.name_step.required' | translate }}</p>
                }

                @if (nameTooShort()) {
                  <p class="mt-3 text-sm text-rose-600">{{ 'ugc_create.name_step.min_length' | translate }}</p>
                }

                @if (nameCheckError()) {
                  <div class="ugc-create-inline-alert mt-4">
                    <p class="text-sm font-semibold text-rose-700">{{ 'ugc_create.name_step.error_title' | translate }}</p>
                    <p class="mt-2 text-sm leading-6 text-rose-600">{{ nameCheckError() }}</p>
                  </div>
                }
              </section>

              @if (flowStep() === 'check' && nameCheckResponse()) {
                @if (hasSimilarMatches()) {
                  <section class="ugc-create-search-results-shell">
                    <div class="ugc-create-search-results-shell__header">
                      <div>
                        <h2 class="ugc-create-search-results-shell__title">
                          {{ getResultsTitleKey() | translate }}
                        </h2>
                        <p class="ugc-create-search-results-shell__body">
                          {{ getResultsBodyKey() | translate }}
                        </p>
                      </div>
                    </div>

                    <div class="grid gap-3">
                      @for (match of similarMatches(); track match.id) {
                        <button
                          type="button"
                          class="ugc-create-match-row"
                          (click)="chooseExisting(match)">
                          <div class="ugc-create-match-row__media">
                            <img
                              [src]="getMatchImageUrl(match)"
                              alt=""
                              class="ugc-create-match-row__image" />

                            <div class="ugc-create-match-row__media-overlay"></div>

                            <div class="ugc-create-match-row__media-content">
                              <div class="ugc-create-match-row__meta">
                                <p class="ugc-create-match-row__location">
                                  <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                                    <path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"></path>
                                    <circle cx="12" cy="10" r="2.2"></circle>
                                  </svg>
                                  <span>{{ getMatchLocationLabel(match) }}</span>
                                </p>

                                @if (getMatchDistanceLabel(match); as distanceLabel) {
                                  <span class="ugc-create-match-row__distance">
                                    {{ distanceLabel }}
                                  </span>
                                }
                              </div>
                              <h3 class="ugc-create-match-row__title">{{ match.name }}</h3>
                            </div>

                            <span class="ugc-create-match-row__cta" aria-hidden="true">
                              <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                                <path d="M5 12h14"></path>
                                <path d="m13 6 6 6-6 6"></path>
                              </svg>
                            </span>
                          </div>
                        </button>
                      }
                    </div>

                    @if (showInlineCreateNew()) {
                      <section class="ugc-create-search-decision-card">
                        <div class="ugc-create-search-decision-card__copy">
                          <p class="ugc-create-search-decision-card__title">
                            {{ 'ugc_create.matches.create_new_title' | translate }}
                          </p>
                          <p class="ugc-create-search-decision-card__body">
                            {{ 'ugc_create.matches.create_new_body' | translate }}
                          </p>
                        </div>

                        <button
                          type="button"
                          class="ugc-create-primary-action ugc-create-search-decision-card__cta"
                          (click)="chooseCreateNew()">
                          {{ 'ugc_create.matches.create_new_cta' | translate }}
                        </button>
                      </section>
                    }
                  </section>
                } @else if (showStandaloneCreateNew()) {
                  <section class="ugc-create-search-empty-state ugc-create-search-empty-state--action ugc-create-search-empty-state--standalone">
                    <div class="ugc-create-search-empty-state__icon" aria-hidden="true">
                      <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                        <circle cx="11" cy="11" r="7"></circle>
                        <path d="m20 20-3.5-3.5"></path>
                        <path d="M11 8v6"></path>
                        <path d="M8 11h6"></path>
                      </svg>
                    </div>

                    <div class="ugc-create-search-empty-state__copy">
                      <p class="ugc-create-search-empty-state__title">
                        {{ 'ugc_create.matches.create_new_title' | translate }}
                      </p>
                      <p class="ugc-create-search-empty-state__body">
                        {{ 'ugc_create.matches.create_new_body' | translate }}
                      </p>
                    </div>

                    <button
                      type="button"
                      class="ugc-create-primary-action ugc-create-search-empty-state__cta"
                      (click)="chooseCreateNew()">
                      {{ 'ugc_create.matches.create_new_cta' | translate }}
                    </button>
                  </section>
                } @else if (showBlockedNoResults()) {
                  <section class="ugc-create-search-empty-state ugc-create-search-empty-state--warning ugc-create-search-empty-state--standalone">
                    <div class="ugc-create-search-empty-state__icon" aria-hidden="true">
                      <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="M12 8v5"></path>
                        <path d="M12 16h.01"></path>
                      </svg>
                    </div>

                    <div class="ugc-create-search-empty-state__copy">
                      <p class="ugc-create-search-empty-state__title">
                        {{ 'ugc_create.matches.create_blocked_title' | translate }}
                      </p>
                      <p class="ugc-create-search-empty-state__body">
                        {{ 'ugc_create.matches.create_blocked_body' | translate }}
                      </p>
                    </div>
                  </section>
                }
              }
            </div>
          }

          @if (flowStep() === 'camera' || flowStep() === 'preview') {
            <div class="mt-6 grid gap-4 xl:grid-cols-[minmax(0,1.02fr)_minmax(0,0.98fr)] xl:items-start">
              <section class="space-y-3">
                <div class="ugc-create-camera-stage">
                  <div class="ugc-create-camera-stage__viewport">
                    @if (flowStep() === 'preview' && previewDataUrl()) {
                      <img [src]="previewDataUrl()!" alt="" class="h-full w-full object-cover" />
                    } @else if (!usingFileFallback()) {
                      <video #cameraVideo playsinline autoplay muted class="h-full w-full object-cover"></video>
                    } @else {
                      <div class="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
                        <div class="inline-flex h-14 w-14 items-center justify-center rounded-3xl bg-white/10 text-white">
                          <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                            <path d="M4 7h3l1.5-2h7L17 7h3a1 1 0 0 1 1 1v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a1 1 0 0 1 1-1Z"></path>
                            <circle cx="12" cy="13" r="4"></circle>
                          </svg>
                        </div>
                        <p class="text-base font-semibold text-white">
                          {{ 'ugc_create.camera.fallback_title' | translate }}
                        </p>
                        <p class="max-w-[18rem] text-sm leading-6 text-slate-300">
                          {{ 'ugc_create.camera.fallback_body' | translate }}
                        </p>
                      </div>
                    }

                    <div class="ugc-create-camera-stage__topbar">
                      @if (isNewTarget()) {
                        <span class="ugc-create-soft-pill ugc-create-soft-pill--media ugc-create-soft-pill--accent">
                          {{ 'ugc_create.selection.new' | translate }}
                        </span>
                      }

                      @if (selectedExistingItem(); as existingItem) {
                        <span class="ugc-create-camera-target-chip">
                          {{ existingItem.name }}
                        </span>
                      }

                      @if (locationState() !== 'granted') {
                        <span
                          class="ugc-create-soft-pill ugc-create-soft-pill--media"
                          [class.ugc-create-soft-pill--accent]="currentLocation()"
                          [class.ugc-create-soft-pill--warning]="locationState() === 'denied' || locationState() === 'timeout' || locationState() === 'unavailable' || locationState() === 'error'">
                          {{ getLocationChipKey() | translate }}
                        </span>
                      }
                    </div>

                    @if (flowStep() === 'camera' && !usingFileFallback() && !isStartingCamera()) {
                      <button
                        type="button"
                        class="ugc-create-camera-stage__capture"
                        [attr.aria-label]="'ugc_create.camera.capture_cta' | translate"
                        (click)="captureFromLiveCamera()">
                        <span class="ugc-create-camera-stage__capture-core" aria-hidden="true"></span>
                      </button>
                    }

                    @if (isStartingCamera()) {
                      <div class="absolute inset-0 flex items-center justify-center bg-slate-950/70">
                        <div class="h-11 w-11 animate-spin rounded-full border-2 border-white/20 border-t-white"></div>
                      </div>
                    }
                  </div>
                </div>

                @if (cameraError()) {
                  <div class="ugc-create-inline-alert">
                    <p class="text-sm leading-6 text-amber-700">{{ cameraError() }}</p>
                  </div>
                }

                @if (submissionError()) {
                  <div class="ugc-create-inline-alert">
                    <p class="text-sm font-semibold text-rose-700">{{ 'ugc_create.submit.error_title' | translate }}</p>
                    <p class="mt-2 text-sm leading-6 text-rose-600">{{ submissionError() }}</p>
                  </div>
                }

                <input
                  #cameraInput
                  type="file"
                  accept="image/*"
                  capture="environment"
                  class="hidden"
                  (change)="onFileSelected($event)">
              </section>

              <section class="ugc-create-panel ugc-create-camera-sheet">
                <div>
                  <h2 class="text-[1.35rem] font-semibold leading-[1.08] text-[var(--theme-color-text-base)]">
                    {{ getCameraPanelTitleKey() | translate }}
                  </h2>
                  <p class="mt-2 text-sm leading-6 text-theme-body">
                    {{ getCameraPanelBodyKey() | translate }}
                  </p>
                </div>

                @if (showLocationSupportCard()) {
                  <div
                    class="ugc-create-camera-support"
                    [class.ugc-create-camera-support--soft]="locationState() === 'idle' || locationState() === 'loading'"
                    [class.ugc-create-camera-support--warning]="locationState() === 'denied' || locationState() === 'timeout' || locationState() === 'unavailable' || locationState() === 'error'">
                    <div class="flex items-start gap-3">
                      <span class="ugc-create-camera-support__icon" aria-hidden="true">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                          <path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"></path>
                          <circle cx="12" cy="10" r="2.2"></circle>
                        </svg>
                      </span>

                      <div class="min-w-0">
                        <p class="text-sm font-semibold text-[var(--theme-color-text-base)]">
                          {{ getLocationSupportTitleKey() | translate }}
                        </p>
                        <p class="mt-1.5 text-sm leading-6 text-theme-body">
                          {{ getLocationSupportBodyKey() | translate }}
                        </p>
                      </div>
                    </div>

                    @if (isResolvingLocation()) {
                      <div class="ugc-create-inline-status mt-4">
                        <span class="ugc-create-inline-spinner" aria-hidden="true"></span>
                        <span>{{ 'ugc_create.location.loading' | translate }}</span>
                      </div>
                    }

                    @if (shouldShowLocationRetry()) {
                      <button
                        type="button"
                        class="ugc-create-secondary-action mt-4 w-full"
                        (click)="retryLocation()">
                        {{ 'ugc_create.location.retry_cta' | translate }}
                      </button>
                    }
                  </div>
                }

                @if (showSubmitProgressCard()) {
                  <div class="ugc-create-camera-support ugc-create-camera-support--soft">
                    <div class="ugc-create-inline-status">
                      <span class="ugc-create-inline-spinner" aria-hidden="true"></span>
                      <span>{{ getSubmitPrimaryLabelKey() | translate }}</span>
                    </div>
                    <p class="mt-3 text-sm font-semibold text-[var(--theme-color-text-base)]">
                      {{ getSubmitProgressTitleKey() | translate }}
                    </p>
                    <p class="mt-2 text-sm leading-6 text-theme-body">
                      {{ getSubmitProgressBodyKey() | translate }}
                    </p>
                  </div>
                }

                <div class="flex flex-col gap-3">
                  @if (flowStep() === 'camera') {
                    @if (usingFileFallback()) {
                      <button
                        type="button"
                        class="ugc-create-primary-action w-full"
                        (click)="startFallbackCamera()">
                        {{ 'ugc_create.camera.open_cta' | translate }}
                      </button>
                    }

                    <button
                      type="button"
                      class="ugc-create-secondary-action w-full"
                      (click)="backToCheckStep()">
                      {{ 'ugc_create.camera.review_matches_cta' | translate }}
                    </button>
                  }

                  @if (flowStep() === 'preview') {
                    <button
                      type="button"
                      class="ugc-create-primary-action w-full"
                      [disabled]="!canSubmit()"
                      (click)="submitContribution()">
                      {{ getSubmitPrimaryLabelKey() | translate }}
                    </button>

                    <div class="grid gap-2 sm:grid-cols-2">
                      <button
                        type="button"
                        class="ugc-create-secondary-action w-full"
                        [disabled]="isSubmitting()"
                        (click)="retakePhoto()">
                        {{ 'ugc_create.camera.retake_cta' | translate }}
                      </button>
                      <button
                        type="button"
                        class="ugc-create-secondary-action w-full"
                        [disabled]="isSubmitting()"
                        (click)="backToCheckStep()">
                        {{ 'ugc_create.camera.review_matches_cta' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </section>
            </div>
          }

          @if (flowStep() === 'success' && submittedSubmission(); as submission) {
            <section class="ugc-create-panel ugc-create-panel--accent mt-6">
              <p class="text-xs font-semibold uppercase tracking-[0.16em] custom-base-color">
                {{ 'ugc_create.submit.success_eyebrow' | translate }}
              </p>
              <h2 class="mt-3 text-2xl font-semibold text-black">
                {{ (selectedTarget()?.mode === 'existing' ? 'ugc_create.submit.success_existing_title' : 'ugc_create.submit.success_new_title') | translate }}
              </h2>
              <p class="mt-3 text-sm leading-6 text-theme-body">
                {{ 'ugc_create.submit.success_body' | translate }}
              </p>

              <div class="ugc-create-panel ugc-create-panel--compact mt-5 bg-white/80">
                <p class="text-sm font-semibold text-black">{{ submission.proposedName || xploreName().trim() }}</p>
                <p class="mt-2 text-sm text-theme-body">
                  {{ 'ugc_create.submit.success_status' | translate }}: {{ submission.status }}
                </p>
              </div>

              <div class="mt-5 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  class="ugc-create-primary-action"
                  (click)="restartFlow()">
                  {{ 'ugc_create.submit.new_flow_cta' | translate }}
                </button>
                <a
                  routerLink="/"
                  class="ugc-create-secondary-action">
                  {{ 'ugc_create.submit.back_home_cta' | translate }}
                </a>
              </div>
            </section>
          }
        </section>
      }
    </div>
  </section>
</div>
